import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import Verification from "../Steps/Verification"
import BaseDetails from "../Steps/BaseDetails"
import store from "../../veux/store"

let Teams, step1, step2
let Roles = [
    { Role: 1, Detail: "Player" },
    { Role: 3, Detail: "Coach" },
    { Role: 10, Detail: "Manager" },
    { Role: 6, Detail: "Referee" },
    { Role: 28, Detail: "Scorebench" },

]
// Load Models
const LoadModel = async (Passed) => {
    let result = {
        Portal: 'Basketball ACT Portal',
        MainColor: "#f5924c",
        Logo: require(`../../assets/BACT.png`),
        Title: `<h2>Basketball ACT Registrations</h2>`,
        Description: ``,
        Model: {},
        steps: [
            // Step 1
            step1,
            // Step 2
            step2,
            // Step 3
            {
                stepno: 3,
                title: 'Facilitator led training program',
                valid: true,
                information: ``,
                Model: {},
                Schema: {
                    Role: {
                        type: "select",
                        label: "Select a Role",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Role is Required')],
                        class: 'mx-1 px-1',
                        items: Roles,
                        returnObject: true,
                        itemText: 'Detail',
                        onInput: (ev, portal) => {
                            portal.steps[2].Schema.Team.Role = ev.data.Role.Role
                        },
                    },
                    Team: {
                        type: "select",
                        label: "Select your Team / Entity to Join",
                        outlined: true,
                        dense: true,
                        // col: 12,
                        rules: [rules.requiredMsg('Team is Required')],
                        class: 'mx-1 px-1',
                        items: Teams,
                        returnObject: true,
                        itemText: 'Detail',
                        Role: null,
                        onInput: (ev, portal) => {
                            portal.steps[2].Schema.Team.OUG.Type = ev.data.Team.Type
                        },
                        OUG: { Contact_Roles: true, Type: "Teams" }
                    },
                },
                PreStep: (thisStep, portal) => { },
            },
            // Step 4
            {
                stepno: 4,
                title: 'Finalisation',
                valid: true,
                information: `Thank you for your submitted registration for Basketball ACT.</br>`,
                Model: {},
                Schema: {}
            }
        ]
    }
    // Load the Model with step elements
    result.steps.forEach(element => {
        element.Model = result.Model
    });
    return result
}

export default {
    init: async (Parameters) => {
        step1 = await Verification.LoadSchema(1)
        step2 = await BaseDetails.LoadSchema(2)
        // Teams = await functions.GetCodeBy({ Type: "Teams", Organisation: 3724 }, true);
        Teams = await functions.GetCodeBy({ Organisation: 3724 }, true);
        Teams = Teams.filter(element => { return (element.Type == 'Teams' || element.Type == 'Applications') })
        let result = await LoadModel(Parameters)
        return result;
    },
}